





























import { Vue, Component, Watch } from "vue-property-decorator";
import logger from "@/configs/logger";
import { Route } from "vue-router";

import "./styles/public-header.scss";

@Component
export default class PublicHeader extends Vue {
  onClickLogo() {
    if (window.location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  @Watch("$route")
  onRouteChange(val: Route) {
    if (val.name === "home") {
      document.getElementById("header")!.style.top = "-80px";
    } else {
      document.getElementById("header")!.style.top = "0px";
    }
  }

  mounted() {
    const pathname = window.location.pathname;
    let prevScrollpos = window.pageYOffset;

    if (pathname === "/") {
      document.getElementById("header")!.style.top = "-80px";
    }

    window.onscroll = function HeaderScroll() {
      const currentScrollPos = window.pageYOffset;
      if (pathname === "/") {
        if (document.getElementById("header")) {
          if (prevScrollpos > currentScrollPos && currentScrollPos > 480) {
            document.getElementById("header")!.style.top = "0";
          } else {
            document.getElementById("header")!.style.top = "-80px";
          }
        }
      }
      prevScrollpos = currentScrollPos;
    };
  }
}
